var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.76904 1.38422C2.05951 1.38422 2.29498 1.61969 2.29498 1.91016C2.29498 2.20062 2.05951 2.43609 1.76904 2.43609C1.47858 2.43609 1.24311 2.20062 1.24311 1.91016C1.24311 1.61969 1.47858 1.38422 1.76904 1.38422ZM1.76904 5.38422C2.05951 5.38422 2.29498 5.61969 2.29498 5.91016C2.29498 6.20062 2.05951 6.43609 1.76904 6.43609C1.47858 6.43609 1.24311 6.20062 1.24311 5.91016C1.24311 5.61969 1.47858 5.38422 1.76904 5.38422ZM1.76904 9.38422C2.05951 9.38422 2.29498 9.61969 2.29498 9.91016C2.29498 10.2006 2.05951 10.4361 1.76904 10.4361C1.47858 10.4361 1.24311 10.2006 1.24311 9.91016C1.24311 9.61969 1.47858 9.38422 1.76904 9.38422Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.948127
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalBars);
export default __webpack_public_path__ + "static/media/vertical-bars.dc66fdae784ffc29f3be343d71facb13.svg";
export { ForwardRef as ReactComponent };